// src/hooks/useAutoImportConfigs.ts
import { useState, useEffect, useCallback } from "react";
import { ScheduledJob } from "../AutoImportConfigurations/AddEditAutoImportModal/types/autoImportConfigContextTypes";
const GATEWAY_BASE_URL = process.env.REACT_APP_API_GATEWAY_BASE;

export function useAutoImportConfigs(token: string) {
  const [data, setData] = useState<ScheduledJob[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchConfigs = useCallback(() => {
    if (!token) return;
    setLoading(true);
    fetch(`${GATEWAY_BASE_URL}/datamanager/api/Automation`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch auto import configurations");
        return res.json();
      })
      .then((jobs: ScheduledJob[]) => {
        setData(jobs);
        setError(null);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [token]);

  useEffect(() => {
    fetchConfigs();
  }, [fetchConfigs]);

  return { data, loading, error, refetchConfigs: fetchConfigs };
}
